import React, { Fragment, useContext, useEffect } from "react";
import ClientItem from "./ClientItem";
import Spinner from "../layout/Spinner";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import ClientsContext from "../../context/clients/clientsContext";

const Clients = () => {
  const clientsContext = useContext(ClientsContext);

  const { clients, filtered, getClients, loading } = clientsContext;

  useEffect(() => {
    getClients();
    // eslint-disable-next-line
  }, []);

  // if (clients !== null && clients.length === 0 && !loading) {
  //   return <h4>Please enter a client</h4>;
  // }

  return (
    <Fragment>
      <div style={{ height: "90vh", overflow: "auto" }}>
        {clients !== null && !loading ? (
          <TransitionGroup>
            {filtered !== null
              ? filtered.map(client => (
                  <CSSTransition
                    key={client.id}
                    timeout={500}
                    classNames="item"
                  >
                    <ClientItem client={client} />
                  </CSSTransition>
                ))
              : clients.map(client => (
                  <CSSTransition
                    key={client.id}
                    timeout={500}
                    classNames="item"
                  >
                    <ClientItem client={client} />
                  </CSSTransition>
                ))}
          </TransitionGroup>
        ) : (
          <Spinner />
        )}
      </div>
    </Fragment>
  );
};

export default Clients;
